import { render, staticRenderFns } from "./psychologia-inwestowania-bledy-inwestorow.md?vue&type=template&id=099dcaf0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports